import { httpUtilityUrlEncode } from '@/features/shared/queryParams';

const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// The legacy callers cannot put a '+' or a digit in the path, so the phone number arrives spelled out
// in this codebook. Lowercase input is upper-cased first, like char.ToUpperInvariant did.
const PHONE_NUMBER_CODEBOOK: Record<string, string> = {
  '<': '+',
  U: '+',
  V: '+',
  A: '0',
  T: '0',
  W: '0',
  B: '1',
  S: '1',
  X: '1',
  C: '2',
  R: '2',
  Y: '2',
  D: '3',
  Q: '3',
  Z: '3',
  E: '4',
  P: '4',
  '>': '4',
  F: '5',
  O: '5',
  '-': '5',
  G: '6',
  N: '6',
  '_': '6',
  H: '7',
  M: '7',
  '!': '7',
  I: '8',
  L: '8',
  '*': '8',
  J: '9',
  K: '9',
  $: '9',
};

/** Mirrors the `{id:guid}` route constraint the legacy URLs were served with: no match, no page. */
export function parseLegacyIncidentId(id: string | undefined): string | null {
  return id !== undefined && GUID_PATTERN.test(id) ? id.toLowerCase() : null;
}

export function decodeLegacyPhoneNumber(phoneNumberCode: string): string | null {
  let decoded = '';
  for (const character of phoneNumberCode) {
    const digit = PHONE_NUMBER_CODEBOOK[character.toUpperCase()];
    if (digit === undefined) {
      return null;
    }
    decoded += digit;
  }

  return decoded.startsWith('00') ? `+${decoded.slice(2)}` : decoded;
}

export function buildLegacyCreateIncidentUrl(
  phoneNumberCode: string | undefined,
  id: string | undefined,
): string | null {
  const incidentId = parseLegacyIncidentId(id);
  const phoneNumber = phoneNumberCode === undefined ? null : decodeLegacyPhoneNumber(phoneNumberCode);
  if (incidentId === null || phoneNumber === null) {
    return null;
  }

  return `/create-incident?requestedIncidentId=${incidentId}&phoneNumber=${httpUtilityUrlEncode(phoneNumber)}`;
}
